import * as d3 from 'd3'
export default {

  methods: {

    gauge_Delta() {

      let delta = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.circle.cx},${this.circle.cy})`)

      // Actual Cumulative Progress
      delta
      .append('text')
      .attr('transform', `translate(0, ${-40 + this.title.pro.tSize*0.4})`)
      .attr('font-size', this.title.pro.tSize).attr('fill', this.title.pro.tColor)
      .attr('text-anchor', this.title.pro.align)
      .text(this.title.delta.name)

      let value = delta
      .append('g')
      .attr('id', `DELTA_${this.localId}`)
      .attr('transform', `translate(0, -50)`)

      let col = this.columns.find(f=> f.code == 'DELTA')
      value // Progress
      .append('text')
      .attr('id', `DT_VAL_${this.localId}`)
      .attr('x', 0).attr('y', 0)
      .attr('font-size', col.tSize).attr('fill', this.gmx_deltaValue(this.rawData[col.code]))
      .text(this.rawData[col.code])

      let x_ = this.getNode(`#DT_VAL_${this.localId}`, 'width')
      value // Unit
      .append('text')
      .attr('id', `DT_UNIT_${this.localId}`)
      .attr('transform', `translate(${x_}, 0)`)
      .attr('font-size', col.uSize).attr('fill', this.gmx_deltaValue(this.rawData[col.code]))
      .text(col.unit)

      x_ = x_ + this.getNode(`#DT_UNIT_${this.localId}`, 'width') + 2
      value // Aarow
      .append('path')
      .attr('transform', `translate(${x_}, -9) scale(.7)`)
      .attr('d', this.gmx_deltaValue(this.rawData[col.code], 'icon'))
      .attr('fill', this.gmx_deltaValue(this.rawData[col.code]))
      .attr('stroke-width', .5)

      d3.select(`#DELTA_${this.localId}`)
      .attr('transform', `translate(${-(this.getNode(`#DELTA_${this.localId}`, 'width')/2)}, -50)`)


    },

  }
}